module.exports = __webpack_public_path__ + "img/31.6fec9f1d.jpg";